import moment from "moment";

window.addEventListener('load', (event) => {
    let curDate = moment().format('Y-MM-DD');
    fetch(window.API_Path + 'publicHolidays/isPublicHoliday/' + curDate + '/')
        .then((response) => response.json())
        .then((data) => {
            console.log(data.response)
            if (data.response.jurisdiction === 'NAT' && data.response.isPublicHoliday != false) {
                let notify = document.querySelector('.sitewide_notification')
                if (notify) {
                    fetch(window.API_Path + 'publicHolidays/getPublicHolidayLiterals/')
                        .then((response) => response.json())
                        .then((data) => {
                            console.log(data.response)
                            let text = document.querySelector('#notify-text');
                            let button = document.querySelector('#notify-button');

                            text.innerHTML = data.response.publicHolidayBannerText;
                            if (data.response.bannerButtonLink != '') {
                                button.innerHTML = data.response.bannerButtonText;
                                button.setAttribute('href', data.response.bannerButtonLink);
                                button.classList.add('active');
                            }

                            notify.classList.add('active');

                        });
                }
            }
        });
});


